module.exports = __webpack_public_path__ + "static/media/caramida_aparenta_CK65S_Natural.2304f293.jpg";